import React from "react";
import { useIntl } from "react-intl";
import { PeekBox } from "@piiqtechnologies/ui-components";
import messages from "./messages.i18n";
import { WhiskerConnector } from "./WhiskerConnector";
import { WhiskerMinMaxLabel } from "./WhiskerMinMaxLabel";
export const WhiskerEmptyState = () => {
    const intl = useIntl();
    const minLabel = intl.formatMessage(messages.minLabel);
    const maxLabel = intl.formatMessage(messages.maxLabel);
    return (React.createElement(PeekBox, { sx: { position: "relative", py: 2.5, px: 2 } },
        React.createElement(PeekBox, { sx: { display: "flex", alignItems: "center" } },
            React.createElement(WhiskerMinMaxLabel, { value: "-", caption: minLabel }),
            React.createElement(WhiskerConnector, { side: "left" }),
            React.createElement(PeekBox, { sx: { position: "relative", flexGrow: 1 } },
                React.createElement(PeekBox, { sx: { position: "relative", height: 35, borderRadius: 2, overflow: "hidden", bgcolor: "grey.100" } },
                    React.createElement(PeekBox, { sx: {
                            position: "absolute",
                            height: "100%",
                            width: 4,
                            bgcolor: "grey.400",
                            top: 0,
                            left: "50%",
                            transform: "translateX(-50%)",
                            zIndex: 2,
                        } }))),
            React.createElement(WhiskerConnector, { side: "right" }),
            React.createElement(WhiskerMinMaxLabel, { value: "-", caption: maxLabel }))));
};
export default WhiskerEmptyState;
